/* eslint-disable no-useless-escape */

import moment from "moment";

export const getBase64Blob = async url => {
	try {
		const response = await fetch(url);

		return response.blob();
	} catch (error) {
		return null;
	}
}

export const getFilePreviewThumbUrl = file => {
	const reader = new FileReader();

	reader.readAsDataURL(file);

	return new Promise(resolve => {
		reader.onload = () => {
			resolve(reader.result);
		};
	});
}

export const renameFile = (originalFile, newName) => {
	return new File([originalFile], newName, {
		type: originalFile.type,
		lastModified: originalFile.lastModified
	});
}

export const clearFileName = name => {
	if (!name) {
		return moment().unix();
	}

	const nameSplited = name?.split('_FORM_FIELD_QUESTION_');

	let fileName = nameSplited?.length > 1 ? nameSplited[1] : name;

	let sufix = fileName.split('.');

	sufix = sufix[sufix.length - 1];

	fileName = fileName.slice(0, -1 - sufix.length);
	fileName = fileName.replace(/ /g, '-');
	fileName = fileName.replace(/[\/\\\_\!\#\$\%\&\'\(\)\+\,\.\:\=\@\[\]\^\`\{\}~\s]/g, '_');

	if (fileName.length > 125) {
		fileName = fileName.slice(0, 125);
	}

	return `${fileName}.${sufix}`;


}
